export default __webpack_public_path__ + "static/media/girl1-fajn-lidi.34b0f050.jpg";